<template>
  <div class="page">
    <div class="layout">
      <el-row type="flex" align="middle" justify="space-between">
        <el-col :span="12">
          <div class="page-title">課題列表</div>
        </el-col>
         <el-col :span="4" style="text-align:right;">
          <i style="font-size:20px;cursor: pointer;" @click="onIconClose" class="el-icon-close"></i>
        </el-col>
      </el-row>

      <div class="page-box">
        <el-row :gutter="24" class="page-content-row">
          <el-col :span="3">
            <div class="search-text">課題編號</div>
            <el-input
              v-model="listQuery.numberLike"
              placeholder="請輸入課題編號"
            ></el-input>
          </el-col>
          <el-col :span="3">
            <div class="search-text">語言</div>
            <el-select v-model="listQuery.lang" placeholder="請選擇語言">
              <el-option
                v-for="item in languages"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="3">
            <div class="search-text">年級</div>
            <el-select v-model="listQuery.gradeId" placeholder="請選擇年級">
              <el-option
                v-for="(item, index) in $store.getters.grades"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="3">
            <el-button type="info" @click="onSearch" class="button-el-el">搜尋</el-button>
          </el-col>
          <el-col :span="4">
            <el-button @click="onReset" type="success" class="button-el-el"
              >清除篩選</el-button
            >
          </el-col>
          <el-col :span="4">
              <el-button type="info" class="button-el-el" @click="batchSelect">批量選擇</el-button>
          </el-col>
        </el-row>
        <el-table
          @sort-change="handleSortChange"
          :data="tableData"
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55" align="center"></el-table-column> <!-- 添加复选框列 -->
          <el-table-column
            prop="number"
            label="課題編號"
            align="center"
            sortable="custom"
          >
          </el-table-column>
          <el-table-column
            label="描述"
            align="center"
            width="200px"
          >
           <template slot-scope="{row}">
              <div class="describe-text">{{ row.name }}</div>
           </template>
          </el-table-column>
          <el-table-column
            prop="scope"
            label="課題範圍(島)"
            align="center"
            sortable="custom"
          >
          <template slot-scope="{row}">
                <span>{{row.scope | scope}}</span>
          </template>
          </el-table-column>
          <el-table-column
            prop="lang"
            label="語言"
            align="center"
            sortable="custom"
          >
          <template slot-scope="{row}">
                <span>{{row.lang | language}}</span>
          </template>
          </el-table-column>
          <el-table-column
            prop="gradeId"
            label="年級"
            align="center"
            sortable="custom"
          >
          <template slot-scope="{row}">
               <span>{{row.gradeName}}</span>
          </template>
          </el-table-column>
          <el-table-column
            prop="createdAt"
            label="發佈時間"
            align="center"
            
          >
           <template slot-scope="{row}">
               <span>{{row.createdAt | formatDateTime}}</span>
           </template>
          </el-table-column>
          <el-table-column
            prop="createdAt"
            label="最後更新時間"
            align="center"
            
          >
           <template slot-scope="{row}">
               <span>{{row.updatedAt | formatDateTime}}</span>
           </template>
          </el-table-column>
          <el-table-column
            prop="editor"
            label="最後更新帳號"
            align="center"
            
          >
           <template slot-scope="{row}">
               <span>{{row.editor}}</span>
           </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="{ row }">
              <el-button type="text" size="medium" @click="onSelect(row)">選擇</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <Pagination
      v-show="total > 0"
      :total="total"
      :page.sync="listQuery._page"
      :limit.sync="listQuery._limit"
      @pagination="getTopics"
    />
    <deleteDialog
      titleCh="您確定要刪除此課題嗎？"
      :centerDialogVisible="centerDialogVisible"
      @confirmFunction="confirmFunction"
      @onCancelButton="onCancelButton"
    ></deleteDialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import { payStatus } from "@/biz/static-data";
import { getTopics,deleteTopics } from "@/api/topics";
import deleteDialog from "@/components/deleteDialog";
export default {
  components: { deleteDialog, Pagination },
  props: {
    lang: {
      type: Number,
      default: 0,
    },
    gradeId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      selectedRows: [],
      isRelease:[
        {
          id: 0,
          name: "未發佈"
        },
        {
          id: 1,
          name: "已發佈"
        }
      ],
      total: 0,
      payStatus: [],
      orderId: null,
      dialogSlotVisible: false,
      centerDialogVisible: false,
      listQuery: {
        numberLike: null,
        gradeId: this.gradeId,
        lang: this.lang,
        scope: null,
        orderBy: null,
        _page: 1,
        _limit: 50,
      },
      tableData: [],
    };
  },
  created() {
    this.payStatus = payStatus;
    this.getTopics();
  },
  methods: {
    batchSelect() {
      if (this.selectedRows.length === 0) {
        this.$message.warning('請選擇數據！');
        return;
      }

      // 通过事件传递选中的多行数据
      // this.$emit('batch-select', this.selectedRows);
      // 如果需要同时触发单行选择事件（可选）
      this.selectedRows.forEach(row => {
        let newRow ={
          ...row,
          topicNumber: row.number,
          topicId:row.id
        }
        this.$emit('select', newRow);
      });
    },
     onIconClose(){
      this.$emit("iconClose");
    },
    onSelect(row){
        let newRow ={
          ...row,
          topicNumber: row.number,
          topicId:row.id
        }
        this.$emit('select',newRow)
    },
    // 处理复选框选择变化
    handleSelectionChange(selection) {
      this.selectedRows = selection;
      console.log('选中的行数据:', selection);
    },
    handleSortChange(column) {
      if (column.order === "descending") {
        this.listQuery.orderBy = column.prop + " desc";
      } else if (column.order === "ascending") {
        this.listQuery.orderBy = column.prop + " asc";
      } else {
        this.listQuery.orderBy = null;
      }
      this.listQuery._page = 1;
      this.getTopics();
    },
    onReset() {
      this.listQuery = {
        orderNoLike: null,
        orderDate: null,
        userNo: null,
        gradeId: null,
        lang: null,
        status: null,
        orderBy: null,
        _page: 1,
        _limit: 10,
      };
      this.getTopics();
    },
    onSearch() {
      this.getTopics();
    },
    onCancelButton() {
      this.centerDialogVisible = false;
    },
    confirmFunction() {
      this.deleteTopics();
    },
    onAdd() {
      this.$router.push({ path: `/topic/add` });
    },
    onEditButton(id) {
      this.$router.push({ path: `/topic/${id}/edit` });
    },
    onDetailButton(id) {
      this.$router.push({ path: `/topic/${id}` });
    },
    onDeleteButton(id){
      //弹窗
      this.orderId = id
      this.centerDialogVisible = true;
    },
    deleteTopics(){
      deleteTopics(this.orderId).then(() => {
        this.$message({
          message: '刪除成功',
          type: "success"
        });
        this.getTopics();
      }).finally(()=>{
        this.centerDialogVisible = false;
      })
    },
    getTopics() {
      let formLabelAlign = {
        numberLike: this.listQuery.numberLike,
        gradeId: this.listQuery.gradeId,
        lang: this.listQuery.lang,
        scope: this.listQuery.scope,
        orderBy: this.listQuery.orderBy,
        _page: this.listQuery._page-1,
        _limit: this.listQuery._limit,
      };
      getTopics(formLabelAlign).then((v) => {
        this.tableData = v.data;
        this.total = Number(v.headers["x-total-count"]);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  .layout {
    .el-row {
      padding: 20px;
      margin-bottom: 20px;

      &:last-child {
        margin-bottom: 0;
      }

      .title {
        font-size: 30px;
      }
    }

    .el-button--text {
      color: #166ea5;
      font-size: 16px;
    }
  }
}
.page-box {
  background-color: #fff;
}
.button-el-el {
  width: 100%;
  margin-top: 23px;
}
.describe-text{
  // width: 200px; /* 固定宽度 */
  display: -webkit-box; /* 使用弹性盒子布局 */
  -webkit-box-orient: vertical; /* 垂直方向排列 */
  -webkit-line-clamp: 3; /* 最多显示三行 */
  overflow: hidden; /* 超出部分隐藏 */
  text-overflow: ellipsis; /* 超出部分显示省略号 */
  line-height: 1.5; 
}
</style>